/* global axios */
import ApiClient from './ApiClient';

class DataTransferAPI extends ApiClient {
  constructor() {
    super('data_transfer', { accountScoped: true });
  }

  header(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/header`, formData);
  }

  import(file, mapping, batchLabels) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('mapping', JSON.stringify(mapping));
    if (batchLabels?.length) {
      formData.append('batch_labels', JSON.stringify(batchLabels));
    }
    return axios.post(`${this.url}/import`, formData);
  }

  // Sem id devolve a importação mais recente que o usuário ainda não viu
  importStatus(id) {
    return axios.get(`${this.url}/import_status`, { params: { id } });
  }

  acknowledgeImport(id) {
    return axios.post(`${this.url}/import_acknowledge`, { id });
  }

  example() {
    return axios.get(`${this.url}/example`, { responseType: 'blob' });
  }

  export() {
    return axios.get(`${this.url}/export`, { responseType: 'blob' });
  }
}

export default new DataTransferAPI();
